import {Injectable} from '@angular/core';
import {AbstractProgramService} from './abstract-program.service';
import {ProgramDto, CreateProgramDto, UpdateProgramDto} from "@shared/dto";

@Injectable({
  providedIn: 'root'
})
export class ProgramService extends AbstractProgramService<ProgramDto, CreateProgramDto, UpdateProgramDto> {
}
